import React, { Component,  } from 'react';
import { connect } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import Translate from 'react-translate-component';
import { Alert, Layout } from 'antd';

import { appRun } from 'actions/appActions';
import { pushRollbarError } from 'utils/rollbar';

import LanguageProvider from 'components/LanguageProvider';
import { AppRoutes } from 'components/Routes';
import Modals from 'components/Modals';
import CollapsibleModals from 'components/CollapsibleModals';

const stateToProps = ({ colorScheme }) => ({ colorScheme });

@connect(stateToProps, { appRun })
export default class App extends Component {
    state = {
        error: false
    };

    componentDidCatch(error, stack) {
        pushRollbarError(error, stack);
        this.setState({ error: true });
    }

    componentDidMount() {
        this.props.appRun();

        document.body.classList.add(this.props.colorScheme);
    }

    shouldComponentUpdate (nextProps, nextState) {
        return nextState.error !== this.state.error || nextProps.colorScheme !== this.props.colorScheme;
    }

    render() {
        return (
            <div>
                { this.state.error ? (
                    <Layout className='guest-content'>
                        <div className='guest-wrap'>
                            <div className='guest-layout' onClick={() => window.location.reload()}>
                                <Alert
                                    type='error'
                                    style={{ cursor: 'pointer' }}
                                    message={<Translate content='errors.appError'/>}
                                />
                            </div>
                        </div>
                    </Layout>
                ) : (
                    <LanguageProvider>
                        <Router>
                            <AppRoutes />
                            <Modals />
                            <CollapsibleModals />
                        </Router>
                    </LanguageProvider>
                )}
            </div>
        );
    }
}
